export const /** @type {?} */ AmdMediaQuery = {
    'xs': '(max-width: 599px)',
    'gt-xs': '(min-width: 600px)',
    'sm': '(min-width: 600px) and (max-width: 959px)',
    'gt-sm': '(min-width: 960px)',
    'md': '(min-width: 960px) and (max-width: 1279px)',
    'gt-md': '(min-width: 1280px)',
    'lg': '(min-width: 1280px) and (max-width: 1919px)',
    'gt-lg': '(min-width: 1920px)',
    'xl': '(min-width: 1920px)',
    'landscape': '(orientation: landscape)',
    'portrait': '(orientation: portrait)',
    'print': 'print'
};
//# sourceMappingURL=media-query.constant.js.map
//# sourceMappingURL=media-query.constant.js.map
